const config = require('config');

const lazyLoadingClass = config.lazyLoadingContents.lazyClass;

const getImageTemplate = (metadata) => {
  return `<img crossorigin="anonymous" class="c-video-card__img ${lazyLoadingClass}"
    loading="lazy"
    src="${metadata.thumb}"
    alt="${metadata.title}">`;
};

/**
 * Return HTML card template
 * @param {object} metadata
 */
const renderCardTemplate = (metadata) => `
  <progress class="c-video-card__progress-bar" value="0" max="100"></progress>
  <article class="c-video-card__img-container o-aspect-ratio o-aspect-ratio--16-9" data-videoid="${metadata.assetId}">
    ${getImageTemplate(metadata)}
    <noscript>
      <img crossorigin="anonymous" class="c-video-card__img"  src="${metadata.thumb}" alt="${metadata.title}">
    </noscript>
  </article>
  <p class="c-video-card__title">${metadata.title}</p>`;

/**
 * A function that return a template litteral to create the playlist cards
 * @param {object} metadata The metadata of the video that will populate the card
 * @param {function} callback The callback that will be triggered on - onclick - event
 */
export const playlistCardTemplate = (metadata, callback) => {
  const layoutCard = document.createElement('button');
  layoutCard.className = 'c-playlist-carousel c-video-card c-video-card--offset';
  layoutCard.setAttribute('data-videoid', `${metadata.assetId}`);
  layoutCard.setAttribute('tabindex', '0');
  layoutCard.setAttribute('type', 'button');
  layoutCard.setAttribute('aria-label', 'Play video');
  layoutCard.setAttribute('aria-controls', 'j-player-with-carousel');
  layoutCard.innerHTML = renderCardTemplate(metadata);
  layoutCard.addEventListener('click', (event) => {
    event.stopPropagation();
    callback(metadata);
  });
  layoutCard.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.stopPropagation();
      callback(metadata);
    }
  });
  return layoutCard;
};

const isPrevArrowsInPage = () => {
  return document.getElementsByClassName('prev')[0];
};

const isNextArrowsInPage = () => {
  return document.getElementsByClassName('next')[0];
};

export const leftArrowTemplate = () => {
  if (!isPrevArrowsInPage()) {
    const container = document.getElementsByClassName('c-playlist-carousel__container')[0];
    const leftArrow = `
    <button type="button" aria-label="Mostra video precedente" class="c-playlist-carousel__arrow c-playlist-carousel__arrow--left prev">
      <span>
        <i class="icon icon--arrow icon--arrow-player-sx icon--medium icon--c-light">
          <svg width="80" height="80" viewBox="0 0 80 80"
            xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--arrow-player-sx">
            <path d="M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40zm0-3.478C19.83 76.522 3.478 60.17 3.478 40 3.478 19.83 19.83 3.478 40 3.478 60.17 3.478 76.522 19.83 76.522 40c0 20.17-16.352 36.522-36.522 36.522zm-6.185-35.678l13.527-13.527a1.74 1.74 0 0 0-2.46-2.46L30.127 39.614a1.74 1.74 0 0 0 0 2.46L44.883 56.83a1.74 1.74 0 0 0 2.46-2.46L33.814 40.844z" fill="currentColor" fill-rule="evenodd"></path>
         </svg>
        </i>
      </span>
    </button>`;
    container.innerHTML += leftArrow;
  }
};

export const rightArrowTemplate = () => {
  if (!isNextArrowsInPage()) {
    const container = document.getElementsByClassName('c-playlist-carousel__container')[0];
    const rightArrow = `
    <button type="button" aria-label="Mostra video successivo" class="c-playlist-carousel__arrow c-playlist-carousel__arrow--right next">
      <span>
        <i class="icon icon--arrow icon--arrow-player-dx icon--medium icon--c-light">
          <svg width="80" height="80" viewBox="0 0 80 80"
            xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--arrow-player-dx">
            <path d="M40 80C17.909 80 0 62.091 0 40S17.909 0 40 0s40 17.909 40 40-17.909 40-40 40zm0-3.478c20.17 0 36.522-16.352 36.522-36.522C76.522 19.83 60.17 3.478 40 3.478 19.83 3.478 3.478 19.83 3.478 40 3.478 60.17 19.83 76.522 40 76.522zm6.185-35.678L32.658 27.317a1.74 1.74 0 0 1 2.46-2.46l14.756 14.757c.68.68.68 1.78 0 2.46L35.117 56.83a1.74 1.74 0 0 1-2.46-2.46l13.528-13.527z" fill="currentColor" fill-rule="evenodd"></path>
          </svg>
        </i>
      </span>
    </button>`;
    container.innerHTML += rightArrow;
  }
};

export const removePrevArrow = () => {
  if (isPrevArrowsInPage()) {
    const container = document.getElementsByClassName('c-playlist-carousel__container')[0];
    const prevArrow = document.getElementsByClassName('prev')[0];
    container.removeChild(prevArrow);
  }
};

export const removeNextArrow = () => {
  if (isNextArrowsInPage()) {
    const container = document.getElementsByClassName('c-playlist-carousel__container')[0];
    const nextArrow = document.getElementsByClassName('next')[0];
    container.removeChild(nextArrow);
  }
};
